<template>
 <router-link :to="`/country/${co.name}`">
  <div
   class="
    bg-white
    dark:bg-gray-800 dark:text-gray-200
    w-[250px]
    h-64
    cursor-pointer
    shadow-md
   "
  >
   <img :src="co.flag" class="w-[250px] mb-3 h-[140px] object-cover" />
   <div class="px-4">
    <h1 class="font-bold mb-2">
     {{ co.name.length > 18 ? co.name.slice(0, 18) + "..." : co.name }}
    </h1>
    <h1 class="text-xs font-medium">
     Population : <span class="font-normal">{{ co.population }}</span>
    </h1>
    <h1 class="text-xs font-medium leading-8">
     Capital : <span class="font-normal">{{ co.capital }}</span>
    </h1>
    <h1 class="text-xs font-medium">
     Region : <span class="font-normal"> {{ co.region }} </span>
    </h1>
   </div>
  </div>
 </router-link>
</template>

<script>
export default {
 props: ["co"],
};
</script>